export const INSURANCE_REPORT_STATUS = {
  INSURABLE: "insurable",
  NOT_INSURABLE: "not_insurable",
  UNDER_REVIEW: "under_review",
};

// Temporary placeholder until the definitive not-insurable condition is provided.
const TEMPORARY_NOT_INSURABLE_ERROR_CODES = ["DUMMY_NOT_INSURABLE"];

export const getInsuranceReportStatus = ({
  isInsurable,
  errorCode,
  errorCodes = [],
}) => {
  if (isInsurable === true) return INSURANCE_REPORT_STATUS.INSURABLE;

  const resolvedErrorCodes = [errorCode, ...errorCodes].filter(Boolean);
  if (
    resolvedErrorCodes.some((code) =>
      TEMPORARY_NOT_INSURABLE_ERROR_CODES.includes(code)
    )
  ) {
    return INSURANCE_REPORT_STATUS.NOT_INSURABLE;
  }

  return INSURANCE_REPORT_STATUS.UNDER_REVIEW;
};

export const getInsuranceReviewTooltip = ({
  errorCode,
  errorCodes = [],
  translate,
}) => {
  const resolvedErrorCodes = [errorCode, ...errorCodes].filter(Boolean);
  const includesAny = (codes) =>
    resolvedErrorCodes.some((code) => codes.includes(code));
  const genericDescription = translate(
    "insuranceInsurabilityUnderReviewDescription",
    "There was an issue when checking with the insurance company. Our team has already been notified. Please reopen the report later to check insurability."
  );

  if (includesAny(["NIVEL3_ERR010", "NIVEL3_ERR016", "NIVEL3_ERR022"])) {
    return {
      title: translate(
        "insuranceUnavailableForThisRent",
        "Insurance isn't available for this rent"
      ),
      description: genericDescription,
    };
  }

  if (includesAny(["NIVEL3_ERR043", "NIVEL3_ERR053"])) {
    return {
      title: translate(
        "propertyAlreadyInsured",
        "This property is already insured"
      ),
      description: genericDescription,
    };
  }

  if (includesAny(["NIVEL3_ERR085", "NIVEL3_ERR093"])) {
    return {
      title: translate(
        "tenantAlreadyInAnotherInsuranceRequest",
        "One of the tenants is already in another request"
      ),
      description: genericDescription,
    };
  }

  return {
    title: null,
    description: genericDescription,
  };
};
